export default "__VITE_ASSET__9aa0d6f0__"